import { Box, Button, Tooltip, Typography } from '@mui/material';
import { deleteObjectApi, putUpdateObjectApi, putUpdateObjectListByPropertyValueArrayApi } from 'api/general';
import { postMoveDecisionFilesApi } from 'api/meeting';
import { subjectGroupsFromAgendas, updateSortedAgendaList } from 'app/utils/appHelpers';
import { DECISION } from 'app/utils/constants/customConstant';
import { departmentCardColor, subjectCardTextColor } from 'config';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAllMeetingList, setAllMMList, setCurrentAgenda, setCurrentAgendaList, showAgendaSnackbar } from 'stores/meeting';
import Swal from 'sweetalert2';
import AddPendingAgendaDialog from '../Dialog/AddPendingAgendaDialog';
import AddUpdateAgendaDialog from '../Dialog/AddUpdateAgendaDialog';
import PendingAgendaConfirmDialog from '../Dialog/PendingAgendaConfirmDialog';
import AgendaSubjectCard from './AgendaSubjectCard';
import { updateMeetingAfterUserOperation } from 'app/utils/meetingReduxHelpers';

function AgendaCardListKurul() {
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const [addAgendaDialogStatus, setAddAgendaDialogStatus] = useState(false);
    const [pendingAgendaDialogStatus, setPendingAgendaDialogStatus] = useState(false);
    const [pendingConfirmItem, setPendingConfirmItem] = useState(null);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const { authUser } = useSelector((state) => state.auth);
    const [subjectGroups, setSubjectGroups] = useState([]);
    const currentAgendaList = useSelector((state) => state.meeting.currentAgendaList);
    const [extraGroup, setExtraGroup] = useState([]);


    let allMeetingList = useSelector((state) => state.meeting.allMeetingList);
    let allMMList = useSelector((state) => state.meeting.allMMList);

    useEffect(() => {
        const allGroups = subjectGroupsFromAgendas(currentAgendaList);
        const extras = currentAgendaList.filter(a => a.supp === 'Evet');
        const normalGroups = allGroups
            .map(([subj, ags]) => [subj, ags.filter(a => a.supp !== 'Evet')])
            .filter(([, ags]) => ags.length > 0);
        setSubjectGroups(normalGroups);
        setExtraGroup(extras);

        setData(currentAgendaList);
    }, [currentAgendaList]);


    const handleExtraAgendaSorting = async (subjectId, agendaIndex, direction, updatedAgenda) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });

        // Subject bazında grubu bul ve kendi içinde sırala
        const sg = subjectGroupsFromAgendas(extraGroup);
        const gi = sg.findIndex(([sid]) => sid == subjectId);
        if (gi === -1) return;

        let group = [...sg[gi][1]];
        if (direction === 'none') {
            const targetIdx = updatedAgenda.decisionNo - 1;
            group = group.filter(a => a.id !== updatedAgenda.id);
            group.splice(targetIdx, 0, updatedAgenda);
        } else if (direction === 'up' && agendaIndex > 0) {
            [group[agendaIndex - 1], group[agendaIndex]] = [group[agendaIndex], group[agendaIndex - 1]];
        } else if (direction === 'down' && agendaIndex < group.length - 1) {
            [group[agendaIndex], group[agendaIndex + 1]] = [group[agendaIndex + 1], group[agendaIndex]];
        }

        sg[gi][1] = group;
        const newExtra = sg.flatMap(([, ags]) => ags);
        setExtraGroup(newExtra);

        const all = [
            ...subjectGroups.flatMap(([, ags]) => ags),
            ...newExtra
        ];

        dispatch(await updateSortedAgendaList(all, "index", [], true));
    };

    const handleSubjectSorting = async (subjectIndex, direction) => {


        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });
        const newSubjectGroups = [...subjectGroups];
        if (direction === 'up' && subjectIndex > 0) {
            [newSubjectGroups[subjectIndex - 1], newSubjectGroups[subjectIndex]] =
                [newSubjectGroups[subjectIndex], newSubjectGroups[subjectIndex - 1]];
        } else if (direction === 'down' && subjectIndex < newSubjectGroups.length - 1) {
            [newSubjectGroups[subjectIndex], newSubjectGroups[subjectIndex + 1]] =
                [newSubjectGroups[subjectIndex + 1], newSubjectGroups[subjectIndex]];
        }
        setSubjectGroups(newSubjectGroups);
        const newFlatArray = newSubjectGroups.flatMap(([subjectId, agendas]) => agendas);
        dispatch(await updateSortedAgendaList(newFlatArray, "index", [], true));
    };

    const handleAgendaSorting = async (subjectId, agendaIndex, direction, updatedAgenda) => {


        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });
        const groupIndex = subjectGroups.findIndex(([subjId]) => subjId == subjectId);
        if (groupIndex === -1) return;
        let agendas = subjectGroups[groupIndex][1];
        let newAgendas = [...agendas];
        if (direction === 'none') {
            const targetIndex = updatedAgenda.decisionNo - 1;
            newAgendas = newAgendas.filter(a => a.id !== updatedAgenda.id);
            newAgendas.splice(targetIndex, 0, updatedAgenda);
        } else {
            if (direction === 'up' && agendaIndex > 0) {
                [newAgendas[agendaIndex - 1], newAgendas[agendaIndex]] =
                    [newAgendas[agendaIndex], newAgendas[agendaIndex - 1]];
            } else if (direction === 'down' && agendaIndex < newAgendas.length - 1) {
                [newAgendas[agendaIndex], newAgendas[agendaIndex + 1]] =
                    [newAgendas[agendaIndex + 1], newAgendas[agendaIndex]];
            }
        }
        const newSubjectGroups = subjectGroups.map(([subjId, ags], idx) => {
            if (idx === groupIndex) return [subjId, newAgendas];
            return [subjId, ags];
        });
        setSubjectGroups(newSubjectGroups);


        const newFlatArray = [
            ...newSubjectGroups.flatMap(([_, ags]) => ags),
            ...extraGroup
        ];

        dispatch(await updateSortedAgendaList(newFlatArray, "index", [], true));
    };


    const handleDelete = async (item, type = "agenda", pendingText) => {

        if (type === 'pending' && pendingText === undefined) {
            setPendingConfirmItem(item);
            return;
        }

        if (type !== 'pending') {
            const confirmResult = await Swal.fire({
                title: 'Silme İşlemi',
                text: 'Silme işlemini onaylıyor musunuz?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Evet',
                cancelButtonText: 'Vazgeç',
                customClass: { container: 'swal-container-custom' }
            });
            if (!confirmResult.isConfirmed) {
                return;
            }
        }

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });


        let updatedList = [];
        if (type === "agenda") {

            const result = await deleteObjectApi(DECISION, item.id);
            if (result.status) {

                const sortedAgendaList = [...data].sort((a, b) => a.decisionNo - b.decisionNo);
                const filteredList = sortedAgendaList.filter(x => x.id !== item.id);


                if (filteredList.length > 0) {
                    updatedList = filteredList.map((agenda, index) => ({
                        ...agenda,
                        decisionNo: index + 1,
                    }));
                    await dispatch(await updateSortedAgendaList(updatedList, "", [], true));

                } else {

                    if (authUser.id !== currentMeeting.adminUserId) {
                        await updateMeetingAfterUserOperation(
                            currentMeeting,
                            authUser,
                            dispatch,
                            allMeetingList,
                            allMMList

                        );
                    }

                    dispatch(setCurrentAgendaList([]));
                }

            }


        } else if (type === "pending") {

            let { user, ...pendingAgenda } = item;

            pendingAgenda = {
                ...pendingAgenda,
                meetingId: -1,
                pendingUnitId: currentMeeting.unitId,
                pendingText: pendingText
            }
            const result = await putUpdateObjectApi(DECISION, pendingAgenda);


            if (result.status) {

                const sortedAgendaList_ = [...data].sort((a, b) => a.decisionNo - b.decisionNo);
                const filteredList = sortedAgendaList_.filter(x => x.id !== item.id);


                if (filteredList.length > 0) {
                    updatedList = filteredList.map((agenda, index) => ({
                        ...agenda,
                        decisionNo: index + 1,
                    }));

                    await dispatch(await updateSortedAgendaList(updatedList, "", [], true));

                } else {

                    if (authUser.id !== currentMeeting.adminUserId) {
                        await updateMeetingAfterUserOperation(
                            currentMeeting,
                            authUser,
                            dispatch,
                            allMeetingList,
                            allMMList
                        );
                    }
                    dispatch(setCurrentAgendaList([]));


                }

            }

        }
        Swal.close();
        allMeetingList = allMeetingList.map(meeting => {
            if (meeting.id === currentMeeting.id) {
                return {
                    ...meeting,
                    user: authUser,
                    adminUserId: authUser.id,
                    decisionCount: updatedList.length
                };
            }
            return meeting;
        });

        allMMList = allMMList.map(meeting => {
            if (meeting.id === currentMeeting.id) {
                return {
                    ...meeting,
                    user: authUser,
                    adminUserId: authUser.id,
                    decisionCount: updatedList.length
                };
            }
            return meeting;
        });

        dispatch(setAllMeetingList(allMeetingList));
        dispatch(setAllMMList(allMMList));

        if (type === "agenda") {
            dispatch(showAgendaSnackbar({
                message: `${item.decisionNo} numaralı gündem silindi.`,
                severity: 'error'
            }));
        } else if (type === "pending") {
            dispatch(showAgendaSnackbar({
                message: `${item.decisionNo} numaralı gündem askıya alındı.`,
                severity: 'warning'
            }));
        }

        Swal.fire({
            position: 'center',
            icon: 'success',
            title: type === "pending" ? 'Askıya alma işlemi başarılı.' : 'Silme işlemi başarılı.',
            showConfirmButton: false,
            timer: 2000,
            customClass: {
                container: 'swal-container-custom'
            },
        });


    };



    const closeDialog = () => {
        setAddAgendaDialogStatus(false);
    };

    const updateAgenda = () => {
        setAddAgendaDialogStatus(true);
        dispatch(setCurrentAgenda(null));
    };


    const sortButtonClick = async () => {

        const allAgendas = [
            ...subjectGroups.flatMap(([, ags]) => ags),
            ...extraGroup
        ];

        const updatedAgendas = allAgendas.map((agenda, index) => ({
            ...agenda,
            decisionNo: index + 1
        }));

        const objectList = updatedAgendas
            .filter(agenda => agenda.id !== undefined && agenda.id !== null)
            .map(({ id, decisionNo }) => ({ id, decisionNo }));

        try {
            const result = await putUpdateObjectListByPropertyValueArrayApi(DECISION, "decisionNo", objectList);
            if (result.status) {
                dispatch(setCurrentAgendaList(updatedAgendas));



                if (authUser.id !== currentMeeting.adminUserId) {
                    await updateMeetingAfterUserOperation(
                        currentMeeting,
                        authUser,
                        dispatch,
                        allMeetingList,
                        allMMList
                    );
                }

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Sıralama başarıyla güncellendi.',
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });
            }
        } catch (error) {
            console.error("Sıralama hatası:", error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Sıralama sırasında hata oluştu.',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                    container: 'swal-container-custom'
                },
            });
        }
    };

    const addPendingAgenda = () => {
        setPendingAgendaDialogStatus(true);
        dispatch(setCurrentAgenda(null));
    };

    const handleAddPendingAgenda = async (agendaItem) => {
        let newAgenda = { ...agendaItem };
        if (!newAgenda.decision || (typeof newAgenda.decision === "string" && newAgenda.decision.trim() === "")) {
            newAgenda.decision = newAgenda.agenda;
        }
        newAgenda.meetingId = currentMeeting.id;
        newAgenda.adminUserId = authUser.id;
        newAgenda.agenda = agendaItem.agenda;
        newAgenda.decision = agendaItem.decision;
        newAgenda.pdate = new Date();
        newAgenda.decisionNo = 1;
        const result = await putUpdateObjectApi(DECISION, newAgenda);
        if (result.status) {
            try {
                const moveResult = await postMoveDecisionFilesApi({
                    decisionId: agendaItem.id,
                    newMeetingId: currentMeeting.id,
                    newInst: currentMeeting.inst
                });
                if (!moveResult.status) {
                    const { user, ...revertAgenda } = agendaItem;
                    await putUpdateObjectApi(DECISION, revertAgenda);
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Dosya taşıma sırasında hata oluştu. İşlem geri alındı.',
                        showConfirmButton: true,
                        customClass: { container: 'swal-container-custom' },
                    });
                    return;
                }
            } catch (err) {
                const { user, ...revertAgenda } = agendaItem;
                await putUpdateObjectApi(DECISION, revertAgenda);
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Dosya taşıma sırasında hata oluştu. İşlem geri alındı.',
                    showConfirmButton: true,
                    customClass: { container: 'swal-container-custom' },
                });
                return;
            }

            dispatch(showAgendaSnackbar({
                message: `${newAgenda.decisionNo} numaralı gündem eklendi.`,
                severity: 'success'
            }));

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Ekleme başarılı.',
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    container: 'swal-container-custom'
                },
            });
            const newAgendaWithUser = { id: result.data.insertId, ...newAgenda, user: authUser }
            await dispatch(await updateSortedAgendaList(currentAgendaList, "change", newAgendaWithUser, true));

            allMeetingList = allMeetingList.map(meeting => {
                if (meeting.id === currentMeeting.id) {
                    return {
                        ...meeting,
                        decisionCount: currentAgendaList.length + 1,
                        user: authUser,
                        adminUserId: authUser.id
                    };
                }
                return meeting;
            });

            allMMList = allMMList.map(meeting => {
                if (meeting.id === currentMeeting.id) {
                    return {
                        ...meeting,
                        decisionCount: currentAgendaList.length + 1,
                        user: authUser,
                        adminUserId: authUser.id
                    };
                }
                return meeting;
            });

            dispatch(setAllMeetingList(allMeetingList));
            dispatch(setAllMMList(allMMList));

            setPendingAgendaDialogStatus(false);
        }
    };

    return (
        <>
            <div style={{ margin: 5, padding: 0, textAlign: 'right', width: '99%' }}>

                <Tooltip
                    title="Gündem numaraları ardışık sıralanmadığında kullanınız"
                    arrow
                    placement="top"
                >
                    <Button
                        key="sortButton"
                        variant="outlined"
                        color='inherit'
                        size="small"
                        onClick={() => sortButtonClick()}
                    >
                        Sırala
                    </Button>
                </Tooltip>
                <Button
                    key="addAgenda"
                    variant="outlined"
                    color='inherit'
                    size="small"
                    onClick={updateAgenda}
                >
                    Gündem Ekle
                </Button>
                <Button
                    key="pendingAgenda"
                    variant="outlined"
                    color='inherit'
                    size="small"
                    onClick={addPendingAgenda}
                >
                    Askıdaki Gündemlerden Ekle
                </Button>
            </div>

            {addAgendaDialogStatus && (
                <AddUpdateAgendaDialog
                    open={addAgendaDialogStatus}
                    onClose={closeDialog}
                />
            )}

            {pendingAgendaDialogStatus && (
                <AddPendingAgendaDialog
                    handleAddPendingAgenda={handleAddPendingAgenda}
                    open={pendingAgendaDialogStatus}
                    onClose={() => setPendingAgendaDialogStatus(false)}
                />
            )}

            <PendingAgendaConfirmDialog
                open={Boolean(pendingConfirmItem)}
                agendaId={pendingConfirmItem?.id}
                onClose={() => setPendingConfirmItem(null)}
                onConfirm={(pendingText) => {
                    handleDelete(pendingConfirmItem, 'pending', pendingText);
                    setPendingConfirmItem(null);
                }}
            />

            {subjectGroups.map(([subjectId, agendas], index) => (
                <AgendaSubjectCard
                    key={subjectId}
                    subjectId={subjectId}
                    agendas={agendas}
                    index={index}
                    subjectGroups={subjectGroups}
                    handleSubjectSorting={handleSubjectSorting}
                    handleAgendaSorting={handleAgendaSorting}
                    handleDelete={handleDelete}
                />
            ))}


            {extraGroup.length > 0 && (
                <>
                    <Box sx={{ mt: 1, mb: 1 }}>
                        <Typography sx={{ color: 'error.main', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                            Ek Gündemler / Gündem Sayısı: {extraGroup.length}
                        </Typography>
                    </Box>

                    {subjectGroupsFromAgendas(extraGroup).map(([subjectId, agendas], idx, arr) => (
                        <AgendaSubjectCard
                            key={`extra-${subjectId}`}
                            subjectId={subjectId}
                            agendas={agendas}
                            index={idx}
                            subjectGroups={arr}
                            handleSubjectSorting={async (subjectIndex, direction) => {

                                Swal.fire({
                                    title: 'İşleminiz gerçekleştiriliyor...',
                                    html: '<div><CircularProgress /></div>',
                                    allowOutsideClick: false,
                                    showConfirmButton: false,
                                    customClass: { container: 'swal-container-custom' },
                                    didOpen: () => Swal.showLoading()
                                });

                                const groups = subjectGroupsFromAgendas(extraGroup);
                                let newGroups = [...groups];
                                if (direction === 'up' && subjectIndex > 0) {
                                    [newGroups[subjectIndex - 1], newGroups[subjectIndex]] = [newGroups[subjectIndex], newGroups[subjectIndex - 1]];
                                } else if (direction === 'down' && subjectIndex < newGroups.length - 1) {
                                    [newGroups[subjectIndex], newGroups[subjectIndex + 1]] = [newGroups[subjectIndex + 1], newGroups[subjectIndex]];
                                }
                                const newExtra = newGroups.flatMap(([, ags]) => ags);
                                setExtraGroup(newExtra);
                                const all = [
                                    ...subjectGroups.flatMap(([, ags]) => ags),
                                    ...newExtra
                                ];
                                await dispatch(await updateSortedAgendaList(all, 'index', [], true));
                            }}
                            handleAgendaSorting={(subjectId, agendaIndex, direction, updatedAgenda) =>
                                handleExtraAgendaSorting(subjectId, agendaIndex, direction, updatedAgenda)
                            }
                            handleDelete={handleDelete}
                        />
                    ))}
                </>
            )}

        </>
    );
}

const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);


export default AgendaCardListKurul;
